//引入相关api管理模块
import news from "./news.js";
//进行统一导出
export default {
	news
}